import { Injectable } from '@angular/core';
import { ProductService, RmsContractProductsRequest } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take, tap, catchError } from 'rxjs/operators';
import {
  getActiveExperienceCode,
  getOrderBuilderState,
  OrderBuilderFeatureState,
  OrderBuilderState,
} from '../../../reducers';
import {
  ProductsActionTypes,
  ProductsLoadAction,
  ProductsLoadCompleteAction,
  ProductsResetAction,
} from '../actions/products.actions';
import { RmsSpecificationActionTypes } from '../actions/rms-specification.actions';
import { createProductsRequestPayload } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/utils';

@Injectable()
export class RmsContractProductsEffects {
  loadContractProduct$: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RmsSpecificationActionTypes.INIT),
        tap(() => {
          this.store
            .select(getActiveExperienceCode)
            .pipe(
              take(1),
              filter((expCode) => !expCode || expCode !== ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK),
            )
            .subscribe(() => this.store.dispatch(new ProductsLoadAction()));
        }),
      ),
    { dispatch: false },
  );

  getContractProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductsActionTypes.LOAD),
      switchMap((action: ProductsLoadAction) => {
        return this.store.select(getOrderBuilderState).pipe(
          take(1),
          filter((state) => !!state),
          filter((state) => !!_safe(() => state.locationPage.calendars.calendars[0].subGroup.subGroupCode)),
          map((state: OrderBuilderFeatureState) => createProductsRequestPayload(state)),
          switchMap((request: RmsContractProductsRequest) =>
            this.productService.getContractProducts(request, { NO_RETRY: 'NO_RETRY' }).pipe(
              map((result) => new ProductsLoadCompleteAction(result as any)),
              catchError((error) => {
                return of(new ProductsResetAction());
              }),
            ),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private productService: ProductService,
  ) {}
}
